// What is docked at the bottom of the screen, measured: the phone's tabs and the player bar (phone,
// or a PC page without a spread). A toast (the update prompt, the recording's undo) stands above it
// all instead of covering the player (shell.css `.toast`).
//
// --bottom-chrome on <html> = the height below the page's scroll area (.main ends where the
// player / tabs begin). Measured on resize, when the bars come and go (.main's size changes) and
// when <html>'s classes or style change.
import { useLayoutEffect, type RefObject } from 'react';
import { cssZoom } from './wideScale';

export function useBottomChrome(main: RefObject<HTMLElement | null>): void {
  useLayoutEffect(() => {
    const m = main.current;
    if (!m || typeof ResizeObserver === 'undefined') return;
    const html = document.documentElement;
    let last = '';
    const measure = () => {
      // screen px → the page's own px (a wide screen's zoom: wideScale.ts)
      const below = Math.max(0, window.innerHeight - m.getBoundingClientRect().bottom) / cssZoom(m);
      const v = `${Math.round(below)}px`;
      if (v === last) return;
      last = v;
      html.style.setProperty('--bottom-chrome', v);
    };
    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(m);
    const mo = new MutationObserver(measure);
    mo.observe(html, { attributes: true, attributeFilter: ['class', 'style'] });
    window.addEventListener('resize', measure);
    return () => {
      ro.disconnect();
      mo.disconnect();
      window.removeEventListener('resize', measure);
      html.style.removeProperty('--bottom-chrome');
    };
  }, [main]);
}
